/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Paper from '@material-ui/core/Paper';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import AutoWrapper from 'components/AutoWrapper/AutoWrapper';

import navigation from 'services/NavigationService';

import PageTitle from 'components/PageTitleLegacy/PageTitle';
import styles from './FormWrapper.module.scss';

type TypeProps = {|
  form: Object,
  children: Array<*>,
  title?: string,
  hoistChildren?: number,
|};

@observer
export default class FormWrapper extends React.Component<*> {
  props: TypeProps;

  renderChildren(children: Array<*>): React.Component<*> {
    const hoisted: string = this.props.hoistChildren ? styles.hoisted : '';

    return <div className={`${styles['form-paper-wrapper']} ${hoisted}`}>{children}</div>;
  }

  renderHoistedChildren(children: Array<*>, slicePosition: number): React.Component<*> {
    const slicedChildren: Array<*> = children.slice(slicePosition);

    return (
      <React.Fragment>
        {children.slice(0, slicePosition)}
        {this.renderChildren(slicedChildren)}
      </React.Fragment>
    );
  }

  render(): React.Element<*> {
    const { form, children, title, hoistChildren }: TypeProps = this.props;

    return (
      <AutoWrapper>
        <PageTitle
          title={title || form.name}
          addButton={true}
          cancel={true}
          label="general:actions.cancel"
          onClick={(): void => navigation.goBack()}
        />
        <Paper className={styles['form-paper']} square={true}>
          {hoistChildren
            ? this.renderHoistedChildren(children, hoistChildren)
            : this.renderChildren(children)}
        </Paper>
      </AutoWrapper>
    );
  }
}

FormWrapper.propTypes = {
  title: PropTypes.string,
  form: PropTypes.object,
  children: PropTypes.array,
  hoistChildren: PropTypes.string,
};
